import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectPartner } from "../store/partnerStore";
import { updateTranslationsForPartner } from "../i18n";
import { PARTNER_KEYS, resolvePartnerSync } from "../utils/partner";

const TranslationProvider = ({ children }) => {
  // resolvePartnerSync so the WOW/Leumit bundle applies on the first effect run
  // instead of only after the handshake dispatches setPartner (post-paint text swap).
  const partner = resolvePartnerSync(useSelector(selectPartner));
  const isMehudet = partner === PARTNER_KEYS.MEHUDET;
  const isLeumit = partner === PARTNER_KEYS.LEUMIT;

  useEffect(() => {
    updateTranslationsForPartner(isMehudet, isLeumit);
  }, [isMehudet, isLeumit]);

  return <>{children}</>;
};

export default TranslationProvider;
